import { DateFormatOptionsType } from '../types';

export const FORMAT_DISPLAY_OPTIONS: DateFormatOptionsType = {
  short: { year: 'numeric', month: '2-digit', day: '2-digit' }, // 'MM/DD/YYYY',
  condensed: { year: 'numeric', month: 'short', day: 'numeric' }, // MMM D, YYYY
  condensedWithTime: {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'short',
  }, // MMM D, YYYY, h:mm a TZ
  month: { year: 'numeric', month: '2-digit' }, // MM/YYYY
  monthCondensed: { year: 'numeric', month: 'short' }, // MMM YYYY
  long: {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'short',
  }, // MM/DD/YYYY, h:mm a TZ
};
